import { render, staticRenderFns } from "./horizontal-ranking-traditional.vue?vue&type=template&id=edb1e86e&"
import script from "./horizontal-ranking-traditional.vue?vue&type=script&lang=js&"
export * from "./horizontal-ranking-traditional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports